import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type UserAction = ActionType<typeof actions>;

export enum UserActionTypes {
  FETCH_REQUEST = "@User/FETCH_REQUEST",
  FETCH_SUCCESS = "@User/FETCH_SUCCESS",
  FETCH_ERROR = "@User/FETCH_ERROR",

  SELECT_GATE = "@User/SELECT_GATE",
}

export interface PartnerGate {
  readonly id: number;
  readonly label: string;
  readonly permissions: string[];
}

export interface User {
  readonly defaultGateId: number;
  readonly username: string;
  readonly isAdmin: boolean;
  readonly availableGates: PartnerGate[];
  readonly userPermissions: string[];
}

export interface UserState extends User {
  readonly selectedGate: PartnerGate;
  readonly permissions: string[];
  readonly isLoaded: boolean;
}
